import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// src/main.jsx (top of file, just for debugging)
import { apiBase } from './config/apiConfig'
console.log('[API BASE]', apiBase(''))  // should log the full CF base in production

const root = createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
